import React, { useState } from 'react';
import { useStore } from '../context/StoreContext';

export default function ProfilePage() {
  const { userEmail, isLoggedIn, setLoginModalOpen, orders } = useStore();
  const [addresses, setAddresses] = useState([
    { id: 1, label: 'Home', address: '123 Fashion Street, Downtown, 110001', isDefault: true },
    { id: 2, label: 'Office', address: 'WeWork, Sector 62, Noida, 201301', isDefault: false },
  ]);
  const [newAddress, setNewAddress] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);

  if (!isLoggedIn) {
    return (
      <div className="min-h-[70vh] flex items-center justify-center px-4">
        <div className="text-center">
          <div className="w-24 h-24 bg-gradient-to-br from-indigo-100 to-fuchsia-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-user-line text-4xl text-indigo-600"></i>
          </div>
          <h1 className="text-3xl font-display font-bold mb-3">Welcome Back</h1>
          <p className="text-slate-500 mb-6">Please login to view your profile</p>
          <button onClick={() => setLoginModalOpen(true)} className="bg-gradient-to-r from-indigo-600 to-fuchsia-600 text-white px-8 py-3 rounded-full font-semibold shadow-lg hover:shadow-xl transition">
            Login / Sign Up
          </button>
        </div>
      </div>
    );
  }

  const totalOrders = orders.length;
  const totalSpent = orders.reduce((sum, o) => sum + o.total, 0);

  const addAddressHandler = () => {
    if (newAddress.trim()) {
      setAddresses([...addresses, { id: Date.now(), label: `Address ${addresses.length+1}`, address: newAddress, isDefault: false }]);
      setNewAddress('');
      setShowAddForm(false);
    }
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      {/* Hero header */}
      <div className="relative mb-10">
        <div className="absolute inset-0 bg-gradient-to-r from-indigo-600/10 to-fuchsia-600/10 rounded-3xl blur-3xl -z-10"></div>
        <h1 className="text-4xl md:text-5xl font-display font-bold bg-gradient-to-r from-indigo-700 to-fuchsia-700 bg-clip-text text-transparent">My Profile</h1>
        <p className="text-slate-500 mt-2">Manage your account and saved addresses</p>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {/* Profile Card */}
        <div className="md:col-span-1">
          <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm hover:shadow-md transition">
            <div className="flex flex-col items-center text-center">
              <div className="w-24 h-24 rounded-full bg-gradient-to-br from-indigo-500 to-fuchsia-500 flex items-center justify-center text-white text-3xl font-bold mb-4 shadow-lg">
                {userEmail[0].toUpperCase()}
              </div>
              <h3 className="text-xl font-bold">{userEmail.split('@')[0]}</h3>
              <p className="text-slate-500 text-sm">{userEmail}</p>
              <div className="w-full mt-4 pt-4 border-t grid grid-cols-2 gap-2">
                <div className="text-center">
                  <p className="text-2xl font-bold text-indigo-600">{totalOrders}</p>
                  <p className="text-xs text-slate-500">Orders</p>
                </div>
                <div className="text-center">
                  <p className="text-2xl font-bold text-fuchsia-600">₹{totalSpent.toLocaleString()}</p>
                  <p className="text-xs text-slate-500">Total Spent</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Addresses Section */}
        <div className="md:col-span-2">
          <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold flex items-center gap-2"><i className="ri-map-pin-line text-indigo-500"></i> Saved Addresses</h2>
              <button onClick={() => setShowAddForm(!showAddForm)} className="text-indigo-600 text-sm font-semibold hover:underline">
                + Add New
              </button>
            </div>

            {showAddForm && (
              <div className="mb-4 p-3 bg-slate-50 rounded-xl border">
                <input 
                  type="text" 
                  value={newAddress} 
                  onChange={e => setNewAddress(e.target.value)}
                  placeholder="Full address with pincode" 
                  className="w-full border rounded-xl p-2 mb-2"
                />
                <div className="flex gap-2">
                  <button onClick={addAddressHandler} className="bg-indigo-600 text-white px-4 py-1.5 rounded-lg text-sm">Save</button>
                  <button onClick={() => setShowAddForm(false)} className="border px-4 py-1.5 rounded-lg text-sm">Cancel</button>
                </div>
              </div>
            )}

            <div className="space-y-3">
              {addresses.map(addr => (
                <div key={addr.id} className={`p-4 rounded-xl border ${addr.isDefault ? 'border-indigo-300 bg-indigo-50/30' : 'border-slate-200'} transition hover:shadow-sm`}>
                  <div className="flex justify-between items-start">
                    <div>
                      <div className="flex items-center gap-2">
                        <p className="font-semibold">{addr.label}</p>
                        {addr.isDefault && <span className="text-[10px] bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded-full">Default</span>}
                      </div>
                      <p className="text-sm text-slate-600 mt-1">{addr.address}</p>
                    </div>
                    <div className="flex gap-2">
                      <button className="text-slate-400 hover:text-indigo-600"><i className="ri-edit-line"></i></button>
                      <button className="text-slate-400 hover:text-red-500"><i className="ri-delete-bin-line"></i></button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}